/**
 * betCardFormatters.js — Pure display helpers extracted from UnifiedBetCard.jsx
 * (god-file decomposition). No React, no I/O — safe to unit-test and share
 * with BetCardV2 / NewResultsView.
 */

import * as betMath from './betMath';

export const formatOdds = (price) => {
    if (price === null || price === undefined || isNaN(price)) return '—';
    const num = Number(price);
    return num > 0 ? `+${num}` : `${num}`;
};

export const extractPrice = (bookOddsValue) => {
    if (bookOddsValue === null || bookOddsValue === undefined) return null;
    if (typeof bookOddsValue === 'object' && bookOddsValue.price !== undefined) {
        return bookOddsValue.price;
    }
    if (typeof bookOddsValue === 'number') return bookOddsValue;
    return null;
};

export const getImpliedProbability = (price) => betMath.americanToImplied(price);

export const detectSportType = (sport, league, title = '', description = '') => {
    const s = (sport || '').toLowerCase();
    const l = (league || '').toLowerCase();
    const isSinglePlayer = s.includes('tennis') || l.includes('atp') || l.includes('wta') || s.includes('golf') || l.includes('pga');
    const isCombatSport = s.includes('boxing') || s.includes('mma') || l.includes('ufc') || l.includes('bellator');
    return { isSinglePlayer, isCombatSport };
};

// Sanitize selection strings that arrive from the API with per-character spacing artifacts.
// Some OpticOdds API responses store selections with invisible Unicode chars or literal
// spaces between each character (e.g. "C l e v e l a n d" instead of "Cleveland").
// Detects when >50% of space-separated tokens are single characters and collapses them.
export const sanitizeSelectionString = (str) => {
    if (!str || typeof str !== 'string') return str;
    let s = str.replace(/[\u200B\u200C\u200D\uFEFF\u00AD\u180E\u2060]/g, '');
    const tokens = s.split(' ');
    const singleCharCount = tokens.filter(t => t.length <= 1).length;
    if (tokens.length > 4 && singleCharCount / tokens.length > 0.5) {
        s = s.replace(/([A-Za-z0-9+.\-]) ([A-Za-z0-9+.\-])/g, '$1$2');
        s = s.replace(/([A-Za-z0-9+.\-]) ([A-Za-z0-9+.\-])/g, '$1$2');
    }
    return s;
};

export const isPlayerPropMarket = (market) => {
    const m = (market || '').toLowerCase();
    // Markets explicitly named for a player stat are always player props
    if (m.includes('player')) return true;
    // Exclude team/game aggregate markets that share stat keywords with player props
    // e.g. "Team Total Assists", "1st Quarter Total Points", "Total Steals"
    if (m.includes('team') || /\btotal\b/.test(m)) return false;
    // Sport-specific keywords that only appear in player prop contexts (never team totals)
    return m.includes('passing') || m.includes('rushing') || m.includes('receiving') ||
           m.includes('strikeouts') || m.includes('fantasy');
};

export const isTeamPropWithAlts = (market) => {
    const m = (market || '').toLowerCase();
    return m.includes('spread') || m.includes('total') || m.includes('handicap') || 
           m.includes('puck line') || m.includes('run line') || m.includes('team total');
};
